import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MagicEightBall from "./pages/MagicEightBall";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MagicEightBall />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
